import React, { useRef } from 'react'
import "./Contact.css"
import { AiOutlineMail, AiFillLinkedin } from 'react-icons/ai'
import { FaFacebookMessenger } from 'react-icons/fa'
import emailjs from 'emailjs-com'




const Contact = () => {
    const form = useRef()

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_76bvtcm', 'template_x4728zb', form.current, 'ZJKfRCSkPNnrw4Dtw')
            .then((result) => {
                console.log(result.text);
                e.target.reset()
            }, (error) => {
                console.log(error.text);
            });
    };
    return (
        <section id="contact">
            <h5>Let's Talk</h5>
            <h2><b>Contact Me</b></h2>

            <div className="container contact__container">
                <div className="contact__options">
                    <article className="contact__option">

                        <AiOutlineMail className='contact__option-icon' />
                        <h4>E-mail</h4>
                        <h5>johnpauldsalazar@gmail.com</h5>
                        <a href="mailto:johnpauldsalazar@gmail.com" target='_blank'>Send me a message</a>

                    </article>

                    <article className="contact__option">

                        <FaFacebookMessenger className='contact__option-icon' />
                        <h4>Messenger</h4>
                        <h5>Paul D Salazar</h5>
                        <a href="https://www.facebook.com/johnpaul.d.salazar" target='_blank'>Send me a message</a>

                    </article>

                    <article className="contact__option">

                        <AiFillLinkedin className='contact__option-icon' />
                        <h4>Linkedin</h4>
                        <h5>John Paul D. Salazar</h5>
                        <a href="https://www.linkedin.com/in/john-paul-salazar-224659193/" target='_blank'>Send me a message</a>

                    </article>
                </div>

                <form ref={form} onSubmit={sendEmail}>

                    <input type="text" name='name' placeholder='Enter Your Full Name' required />
                    <input type="email" name="email" placeholder='Enter Your E-mail Address' required />

                    <textarea name="message" placeholder='Start Typing...' rows="8" required></textarea>

                    <button type="submit" className='btn btn-primary'> Send Message</button>
                </form>

            </div>
        </section>
    )
}

export default Contact